// import loginService from "@services/auth/login";
import Cookies from "universal-cookie";
import {
  useDashboardUIActions,
} from "@contexts/dashboardUI";
import { useAuthContext } from ".";

const cookies = new Cookies();

// Bearer header for the admin-only auth calls. The back-office now gates listUsers /
// updateCompanies at the API Gateway and gates register-with-roles / resetPassword's
// admin branch in-handler, so those requests must carry the logged-in admin's token.
// Returns {} when there is no token (public flows: forgot-password) so they stay open.
const authHeader = () => {
  const { token } = cookies.get("userId") || {};
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export default (state, dispatch) => {
  const login = async (data) => {
    const response = await fetch(`${process.env.SERVER_URL}/auth`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data)
    })

    if (response.ok) {
      const { user } = await response.json();
      cookies.set("auth", user, {
        path: "/",
        sameSite: "lax",
      });
      cookies.set("userId", { id: user._id, token: user.token }, {
        path: "/",
        sameSite: "lax",
      })
      // localStorage.setItem("userId", JSON.stringify(user._id));
      // localStorage.setItem("user", JSON.stringify(user));
      // cookies.set("auth", user)
      dispatch({
        type: "LOGGED_IN",
        data: user,
      });
    } else {
      dispatch({
        type: "WRONG_CREDENTIALS",
      });
    }
  };

  const logout = async (data) => {
    // cookies.remove("auth");
    cookies.remove("auth", { path: "/" });
    cookies.remove("userId", { path: "/" });
    // localStorage.removeItem("userId");
    dispatch({
      type: "LOGGED_OUT",
    });
  };

  const checkAuth = async () => {
    // const claim = cookies.get("claim")
    // console.log(claim)
    const remember = cookies.get("userId");
    if (!remember) {
      dispatch({ type: "COOKIE_CHECKED" });
      return
    }
    const response = await fetch(`${process.env.SERVER_URL}/auth/checkUserUpdates`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${remember.token}`,
      },
    }).then(res => {
      return res.json()
    })
    dispatch({
      type: "COOKIE_CHECKED",
      data: response.user,
    });
    // 
  };

  const updatePassword = async data => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.SERVER_URL}/auth/update`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: JSON.stringify(data)
    })
    setIsLoading(false)
    return response
  }

  const createUser = async data => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.SERVER_URL}/auth/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: JSON.stringify(data)
    })
    setIsLoading(false)
    const { message, newUser, userInsertResult } = await response.json();
    return { code: response.status, message, newUser, userInsertResult }
  }

  const updateUser = async data => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true);
    const response = await fetch(`${process.env.SERVER_URL}/auth/updateCompanies`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: JSON.stringify(data)
    });
    setIsLoading(false);
    const body = await response.json();
    return { ok: response.ok, code: response.status, ...body };
  };

  const deleteUser = async _id => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.SERVER_URL}/auth/deleteUser`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: JSON.stringify({ _id })
    });
    const body = await response.json();
    setIsLoading(false)
    return { ok: response.ok, code: response.status, ...body };
  };

  const resetPassword = async data => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.SERVER_URL}/auth/resetPassword`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeader() },
      body: JSON.stringify(data)
    }).then(res => { return res.json() })
    setIsLoading(false)
    return response
  }

  const listUsers = async (company) => {
    const { setIsLoading } = useDashboardUIActions();
    setIsLoading(true)
    const response = await fetch(`${process.env.SERVER_URL}/auth/listUsers?companyId=${company || ""}`, {
      method: "GET",
      headers: { ...authHeader() }
    }).then(res => {
      return res.json()
    })
    setIsLoading(false)
    return response
  }

  return {
    login,
    logout,
    checkAuth,
    updatePassword,
    createUser,
    listUsers,
    updateUser,
    deleteUser,
    resetPassword
  };
};
